import React, { useState } from "react";
import { Container, Button, Card } from "react-bootstrap";
import confetti from "canvas-confetti";
import { Gift } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { BACKEND_URL } from "../config";
import axios from "axios";

export default function SurpriseButton() {
  const [showSurprise, setShowSurprise] = useState(false);
  const [currentJoke, setCurrentJoke] = useState("");
  const [loading, setLoading] = useState(false);

  const launchConfetti = () => {
    confetti({
      particleCount: 120,
      spread: 80,
      origin: { y: 0.5 },
    });
  };

  const handleSurpriseClick = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${BACKEND_URL}api/jokes/get`);
      setCurrentJoke(
        data.text || "Where do vampires keep their money? At the blood bank."
      );
      setShowSurprise(true);
      launchConfetti();
    } catch (error) {
      setCurrentJoke("Failed to fetch :( Try again!");
      setShowSurprise(true);
    }
    setLoading(false);
  };

  const resetSurprise = () => {
    setShowSurprise(false);
    setCurrentJoke("");
  };

  return (
    <Container
      fluid
      className="d-flex flex-column justify-content-center align-items-center"
    >
      {!showSurprise ? (
        <Button
          size="md"
          variant="success"
          className=" fw-semibold px-4 py-2 shadow"
          onClick={handleSurpriseClick}
          disabled={loading}
        >
          {loading ? (
            "Loading..."
          ) : (
            <>
              Surprise&nbsp;Me! <Gift className="ms-2" />
            </>
          )}
        </Button>
      ) : (
        <Card
          className="text-center p-1 shadow-lg border-0 position-relative"
          style={{ backdropFilter: "blur(8px)", maxWidth: 420 }}
        >
          {/* Close Icon */}
          <Button
            variant="light"
            className=" position-absolute top-0 end-0 m-3"
            aria-label="Close"
            onClick={resetSurprise}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>

          <Card.Body className="p-4">
            <div className="display-6 mb-3">🎉</div>
            <h2 className="h4 fw-bold mb-2">Surprise!</h2>
            <p className="text-muted mb-4">Here's a tip for you:</p>

            <div className="bg-warning bg-opacity-25 rounded p-3 mb-0">
              <p className="mb-0 fs-6">{currentJoke}</p>
            </div>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
}
